import TeamMap from '../TeamMap';
import EditButton from '../../../components/ui/EditButton';
import { normalizeAddress } from '../utils/normalizeAddress';

export default function AddressCard({ address, onEdit, isAdmin }) {
  const normalizedAddress = normalizeAddress(address);
  const { street, city, state, postcode, country } = normalizedAddress;

  const hasAddress = street || city || state || postcode || country;

  return (
    <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Address</span>
        {isAdmin && (<EditButton section="address" onEdit={onEdit} />)}
      </div>
      <div className="card-body">
        {hasAddress ? (
          <>
            <p className="mb-2">
              {street && <>{street}<br /></>}
              {city && <>{city}, </>}
              {state && <>{state} </>}
              {postcode && <>{postcode}<br /></>}
              {country}
            </p>
            <div className="map-container">
              <TeamMap address={normalizedAddress} />
            </div>
          </>
        ) : (
          <p className="text-muted">No address has been set yet.</p>
        )}
      </div>
    </div>
  );
}
